import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useTabContext from 'common/hooks/useTabContext';
import { isEmpty } from 'lodash';
import { getAuthorizations, getGuarantors, getPatientInsurances } from 'store/thunks/patientThunks';
import { getPartners } from 'store/thunks/partnerThunks';
import PatientInsuranceTab from './Insurances/PatientInsuranceTab';
import PatientGuarantorsTab from './Guarantors/PatientGuarantorsTab';
import PatientAuthorizationTab from './Authorizations/PatientAuthorizationTab';
import PatientPartnersTab from './Partners/PatientPartnersTab';

const InsurancesTab = () => {
  const { mpi } = useParams();
  const dispatch = useDispatch();
  const isActiveTab = useTabContext().tab === 'PatientInsuranceTab';
  const partners = useSelector(({ auth, partner }) => partner[auth.currentTenantId]);

  useEffect(() => {
    if (isActiveTab) {
      dispatch(getPatientInsurances({ mpi }));
      dispatch(getGuarantors({ mpi }));
      dispatch(getAuthorizations({ mpi }));
    }
  }, [dispatch, mpi, isActiveTab]);

  useEffect(() => {
    if (isActiveTab && isEmpty(partners)) {
      dispatch(getPartners({ mpi }));
    }
  }, [partners, dispatch, mpi, isActiveTab]);

  if (!isActiveTab) {
    return null;
  }

  return (
    <Grid container direction='column'>
      <Grid item>
        <PatientInsuranceTab />
      </Grid>

      <Grid item>
        <PatientGuarantorsTab />
      </Grid>

      <Grid item>
        <PatientAuthorizationTab />
      </Grid>

      <Grid item>
        <PatientPartnersTab />
      </Grid>
    </Grid>
  );
};

export default InsurancesTab;
